import { render, staticRenderFns } from "./PersonalNotification.vue?vue&type=template&id=a07d43fa&scoped=true&"
import script from "./PersonalNotification.vue?vue&type=script&lang=js&"
export * from "./PersonalNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07d43fa",
  null
  
)

export default component.exports